// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { CPerson_abstract } from './../abstract/SagaSchema/CPerson_abstract';
export class CPerson extends CPerson_abstract {
  static formsProperties = {
    info: ['LastName', 'FirstName', 'Address', 'Location', 'Nationality', 'Text'],
    description: ['Kind', 'Gender', 'Age', 'Build', 'Height', 'EyeColor', 'HairColor', 'Dress', 'Particulars']
  };
}
